import { render } from "./ModalNuovaRichiesta.vue?vue&type=template&id=63d1960b&scoped=true"
import script from "./ModalNuovaRichiesta.vue?vue&type=script&lang=js"
export * from "./ModalNuovaRichiesta.vue?vue&type=script&lang=js"

import "./ModalNuovaRichiesta.vue?vue&type=style&index=0&id=63d1960b&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_entasys/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d1960b"]])

export default __exports__